import React from 'react';
import PropTypes from "prop-types";

const ModalCancelButton = ({buttonDisabled, onClick, children}) =>
{
    const clickHandler = buttonDisabled === false ? onClick : null;

    return (
        <button onClick={clickHandler} type='button' style={{marginRight: '10px', marginLeft: '10px'}} disabled={buttonDisabled}
                className='btn btn btn-secondary btn-small'>{children}<i className="et-save"/>
        </button>
    )
}

export default ModalCancelButton;

ModalCancelButton.defaultProps =
{
    buttonDisabled: false,
    onClick: null
}

ModalCancelButton.propTypes = {
    onClick: PropTypes.func,
    buttonDisabled: PropTypes.bool
};
